import { Injectable } from '@angular/core';
var MarkdownConfig = (function () {
    function MarkdownConfig() {
    }
    return MarkdownConfig;
}());
export { MarkdownConfig };
/** config modue */
MarkdownConfig.decorators = [
    { type: Injectable },
];
/** @nocollapse */
MarkdownConfig.ctorParameters = function () { return []; };
//# sourceMappingURL=markdown.config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-markdown/markdown/markdown.config.js
// module id = 202
// module chunks = 0